import { Enum } from "./Enum";

export const ROUNDROBIN = Object.freeze({
  ADĐ_TIME_SLOT: `/round-robin/time-slot`,
  GET_TIME_SLOT: `/round-robin/time-slot`,
  AGENT_STATUS: (agencyId: string) => `/round-robin/status/${agencyId}`,
  UPDATE_AGENTS: (timeSlotId: string) =>
    `/round-robin/time-slot/${timeSlotId}/update-agents`,
  DISTRIBUTED_HISTORY: `/round-robin/history`,
  REMOVE: (id: string) => `/round-robin/time-slot/${id}`,
  TIME_SLOT_CONFIG: `/round-robin/config`,
  USER_SUB_ACCOUNT: `/round-robin/user-sub-account`,
  GET_USER: `/round-robin/user`,
  QUEUE: `/round-robin/queue`,
});

export type E_ROUNDROBIN = Enum<typeof ROUNDROBIN>;
